<template>
  <div>
    <el-card>
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="datetimerange"
            @change="datePickerChange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-select
            style="margin-left: 10px"
            v-model="agesName"
            placeholder="请选择年龄段"
            @visible-change="onClickVisible"
          >
            <el-option
              v-for="item in agsList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Name"
            >
            </el-option>
          </el-select>
          <el-button
            type="goon"
            style="margin-left: 10px"
            @click="GetHe_FoodMoonRecipesList"
            >查询</el-button
          >
          <el-button type="goon" @click="onClickOpen">导出</el-button>
          <el-button type="goon" @click="onEmpty">清空</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column prop="ShowDate" label="日期" align="center">
        </el-table-column>
        <el-table-column prop="Ages" label="年龄段" align="center">
        </el-table-column>
        <el-table-column label="早点" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in foodJson(scope.row.BreakfastJson)"
              :key="index"
            >
              {{ item.value }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="午餐" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in foodJson(scope.row.LunchJson)"
              :key="index"
            >
              {{ item.value }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="午点" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in foodJson(scope.row.AfternoonJson)"
              :key="index"
            >
              {{ item.value }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="肥胖儿餐" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in foodJson(scope.row.FatJson)"
              :key="index"
            >
              {{ item.value }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="营养不良餐" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in foodJson(scope.row.UndernutritionJson)"
              :key="index"
            >
              {{ item.value }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { GetHe_FoodMoonRecipesList, GetGradeList } from "../../../api/api";
import {
  getMonthStartDate,
  getMonthEndDate,
} from "../../../../util/otherRenders";

export default {
  data() {
    return {
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      starttime: [],
      agesName: "",
      agsList: [],
      pickerOptions: {
        // 点击时，选择的是开始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 解除限制
            this.selectData = "";
          }
        },
        disabledDate: (time) => {
          // 是否限制的判断条件
          if (!this.isNull(this.selectData)) {
            var date = new Date(this.selectData);
            // 这里就是限制的关键，大于或者小于本月的日期被禁用
            return (
              date.getMonth() > new Date(time).getMonth() ||
              date.getMonth() < new Date(time).getMonth()
            );
          } else {
            return false;
          }
        },
      },
      userInfo: {},
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    await this.getNowTime();
    await this.GetHe_FoodMoonRecipesList();
  },
  methods: {
    // 导出
    async onClickOpen() {
      window.open(
        `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetHe_FoodMoonRecipesList?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
        "_brank"
      );
    },
    onEmpty() {
      this.agesName = "";
      this.GetHe_FoodMoonRecipesList();
    },
    foodJson(val) {
      if (val) {
        return JSON.parse(val);
      }
    },
    // 年龄段
    async onClickVisible() {
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });
      //console.log(res);
      if (res.data.success) {
        var arr = [
          {
            Id: 0,
            Name: "全年龄",
          },
        ];
        this.agsList = [...arr, ...res.data.response];
        //console.log(this.agsList);
      }
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    async GetHe_FoodMoonRecipesList() {
      const params = {
        Name: this.agesName,
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      };
      let res = await GetHe_FoodMoonRecipesList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
      } else {
        this.tableData = [];
      }
    },
    datePickerChange(e) {},
    async getNowTime() {
      this.starttime.push(getMonthStartDate());
      this.starttime.push(getMonthEndDate());
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>